import { render, staticRenderFns } from "./SofaFabric.vue?vue&type=template&id=786482ce"
import script from "./SofaFabric.vue?vue&type=script&lang=js"
export * from "./SofaFabric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports